

import { Footer } from "../../Footer/Footer"
import { Header } from "../Header/Header"

export const Maxima = () => {

    return (
        <>

            <Header actives="Products" />

            <div className="row px-lg-5" onLoad={() => window.scrollTo(0, 0)}>

                <div className="col-12 col-lg-6 p-2 pe-lg-4 overflow_products border shdows">
                    <img src="Static/Assets/Img/products/Maxima-01.png" alt="" className="products_Alls" />
                </div>

                <div className="col-12 col-lg-6 p-5 overflow_products shdows">
                    <h4 className="text-danger fw-bold  ps-3 "> Maxima (Biostimulant) </h4>
                    <h6 className="py-2 ps-3">
                        Maxima is a Biostimulant which improver plant vigour vegetatively and reproductivly.</h6>
                    <h5 className=" parrot_green py-2 ps-3 text-white border2">Benefits :</h5>
                    <ul>
                        <li> It induces more flowering.</li>
                        <li> Prevents shedding of buds, flowers & fruits. </li>
                        <li>Enlarges fruit size.</li>
                        <li> It Improves crop quality & increses yield. </li>

                    </ul>
                    <h5 className=" parrot_green py-2 ps-2 text-white border2">Crops :</h5>
                    <ul>
                        <li>
                            Recommended for all Vegetables & fruits
                        </li>

                    </ul>
                    <h5 className=" parrot_green py-2  ps-3 text-white border2">Dosage :</h5>
                    <ul>
                        <li>
                            500 ml/ acre for spraying
                        </li>
                    </ul>

                    <h5 className=" parrot_green py-2  ps-3 text-white border2">Availability :</h5>
                    <ul>
                        <li>
                            500ml, 1 ltr.
                        </li>
                    </ul>

                </div>

            </div>


            <Footer />


        </>
    )
}
